module.exports = __webpack_public_path__ + "ca45928c34a1497eb6dd683fed999ad1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000O38.png
// module id = 1446
// module chunks = 0